import requests from './requests';

export default {
    all() {
        return requests
            .get('/coach/trainer_applies')
            .then(resp => resp.data);
    },
    get(id) {
        return requests
            .get(`/coach/trainer_apply/${id}`)
            .then(resp => resp.data);
    },
    reject(id) {
        return requests
            .put(`/coach/trainer_apply/${id}/reject`)
            .then(resp => resp.data);
    },
    approve(id) {
        return requests
            .put(`/coach/trainer_apply/${id}/approve`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/trainer_apply.js